import HeroCarousel from '../components/HeroCarousel'
import JourneyIntro from '../components/JourneyIntro'
import VideoIntro from '../components/VideoIntro' 
import OurServices from '../components/OurServices'

function Home() {
  return (
    <>
    <HeroCarousel/>
    <JourneyIntro/>
    <VideoIntro/>
    <OurServices />
    
    </>
  )
}

export default Home